"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _redux = require("redux");

var _campaignCreator = _interopRequireDefault(require("./campaignCreator"));

var _data = _interopRequireDefault(require("./data"));

var _options = _interopRequireDefault(require("./options"));

var _characteristics = require("./characteristics");

var _superSegments = require("./superSegments");

var _digitalAudiences = require("./digitalAudiences");

var _contact = require("./contact");

var _groupedPersona = require("./groupedPersona");

var _profilingFilters = require("./profilingFilters");

var _selectedCharacteristics = require("./selectedCharacteristics");

var _selectedMeasure = require("./selectedMeasure");

var _selectedPersonas = require("./selectedPersonas");

var _themeFilter = require("./themeFilter");

var _population = require("./population");

var _featureAccess = require("./featureAccess");

var _universes = require("./universes");

var _categories = require("./categories");

var _findPersonasGrouped = require("./findPersonasGrouped");

var _findPersonasSelected = require("./findPersonasSelected");

var _findPersonasIndividual = require("./findPersonasIndividual");

var _mediaThemeFilter = require("./mediaThemeFilter");

var _mediaFilters = require("./mediaFilters");

var _audienceView = require("./audienceView");

var _communities = require("./communities");

var _messageStreams = _interopRequireDefault(require("./messageStreams"));

var _quadrants = _interopRequireDefault(require("./quadrants"));

var _mapping = _interopRequireDefault(require("./mapping"));

var _fileUploadMeta = _interopRequireDefault(require("./fileUploadMeta"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

// $FlowFixMe
var dataWorkflowReducer = (0, _redux.combineReducers)({
  campaignCreator: _campaignCreator["default"],
  dataPages: _data["default"],
  characteristics: _characteristics.characteristics,
  superSegments: _superSegments.superSegments,
  digitalAudiences: _digitalAudiences.digitalAudiences,
  contact: _contact.contact,
  groupedPersona: _groupedPersona.groupedPersona,
  profilingFilters: _profilingFilters.profilingFilters,
  selectedCharacteristics: _selectedCharacteristics.selectedCharacteristics,
  selectedMeasure: _selectedMeasure.selectedMeasure,
  selectedPersonas: _selectedPersonas.selectedPersonas,
  themeFilter: _themeFilter.themeFilter,
  population: _population.population,
  featureAccess: _featureAccess.featureAccess,
  universes: _universes.universes,
  categories: _categories.categories,
  findPersonasGrouped: _findPersonasGrouped.findPersonasGrouped,
  findPersonasSelected: _findPersonasSelected.findPersonasSelected,
  findPersonasIndividual: _findPersonasIndividual.findPersonasIndividual,
  mediaThemeFilter: _mediaThemeFilter.mediaThemeFilter,
  mediaFilters: _mediaFilters.mediaFilters,
  audienceView: _audienceView.audienceView,
  communities: _communities.communities,
  options: _options["default"],
  messageStreams: _messageStreams["default"],
  quadrants: _quadrants["default"],
  mapping: _mapping["default"],
  fileUploadMeta: _fileUploadMeta["default"]
});
var _default = dataWorkflowReducer;
exports["default"] = _default;